exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "app-conciliacion-chart .error {\n  border: solid thin red; }\n\napp-conciliacion-chart .conciliacion {\n  background-color: white; }\n\napp-conciliacion-chart p-calendar * {\n  height: 100% !important; }\n\napp-conciliacion-chart .input-fecha {\n  margin-top: 1rem;\n  margin-left: 1rem; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src14910448/src/src/app/components/conciliacion/conciliacion-chart.component.scss
// module id = ../../../../../src/app/components/conciliacion/conciliacion-chart.component.scss
// module chunks = main